import $ from 'jquery'
import _ from 'underscore'
import { scrollToElement } from './../../utils/helper'

const elPreloader = '.preloader'
const elPreloaderIcon = '.icon-loading'

function initScrollDownTagSection() {
  const elTriggerScrollDown = '.js-scroll-to-tag-section'

  $(elTriggerScrollDown).click(function(e) {
    e.preventDefault()
    scrollToElement(`#${$(this).data('scrollto')}`, 1200, 40)
  })
}

function hidePreloader() {
  const preloader = $(elPreloader)
  const preloaderIcon = $(elPreloaderIcon)

  if (preloader.length) {
    _.delay(() => {
      $(preloaderIcon).fadeOut(300, () => {
        preloader.fadeOut(900)
      })
    }, 1200)
  }
}

function init() {
  initScrollDownTagSection()
  hidePreloader()
}

export default {
  init
}



// WEBPACK FOOTER //
// ./app/components/effects/effectsView.js